import { createContext, useState } from "react";

const FormContext = createContext({})

export const FormProvider = ({children}:any)=>{
    const [form, setForm] = useState({})

    return(
        <FormContext.Provider value={{form, setForm}}>
            {children}
        </FormContext.Provider>
    )
}

export default FormContext